import { createApp } from 'vue';
import router from './router/';
import App from './App.vue';
import VCalendar from 'v-calendar';
import ModalWindow from './components/ModalWindow';
import InfoBlock from './components/infoblocks/InfoBlock';
import FetchJson from './components/renderless/FetchJson';
import BaseTable from '@/components/base/BaseTable';

const app = createApp(App);
app.component('FetchJson', FetchJson);
app.component('ModalWindow', ModalWindow);
app.component('InfoBlock', InfoBlock);
app.component('BaseTable', BaseTable);
app.use(router);
app.use(VCalendar);
app.mount('#app');
